const { connect } = require('react-redux')
const SuperAgent = require('superagent')
const store = require('../')
const defaultAuthenticationConfig = require('../../config/authentication/uk')
const defaultLoginConfig = require('../../config/navigation/login/uk')
const Tracker = require('../../../_plugins/lib/tracker.js')
const Helpers = require('../../../_plugins/lib/helpers.js')
const Config = require('../../../config/generatedConfig')
const getPPCData = require('../../../_plugins/lib/ppc.js')

const mapStateToProps = state => {
  return {
    loggedInData: state.loggedInData
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { loggedInData = {} } = store
  const getLoginAuthConfig = () => {
    return ownProps.authenticationConfig || defaultAuthenticationConfig
  }
  const getLoginConfig = () => {
    return typeof ownProps.loginConfig === 'object' ? ownProps.loginConfig : defaultLoginConfig
  }
  const onUserLogin = data => {
    const { bookingHistory = {} } = loggedInData
    const { isFetching, isReady, hasError } = bookingHistory

    dispatch({
      type: 'LOGIN',
      data
    })
    if (!isFetching && !isReady && !hasError) {
      dispatch({
        type: 'BOOKING_HISTORY_READY',
        data: data.bookings
      })
    }
  }
  const userLogout = () => {
    const { auth } = getLoginAuthConfig()
    SuperAgent
      .get(auth.logout)
      .withCredentials()
      .end(userLogoutResponse)
  }
  const userLogoutResponse = () => {
    dispatch({
      type: 'LOGOUT'
    })
  }
  const successfulLogin = res => {
    const data = res.body.data.getTraveller ? transformResponse(res.body.data.getTraveller) : res.body
    if (!data.email) return
    Tracker.inline('login_successful', '1')
    data.validUser = true
    const settings = ownProps.settings || Config.settings
    Helpers.setCookie('Email', data.email, false, settings.cookieDomain)
    Helpers.setCookie('email', data.email, false, settings.cookieDomain)
    if (data.address && data.address.user_id) {
      Helpers.setCookie('customerID', data.address.user_id, false, settings.cookieDomain)
    }
    if (data.vehicle && data.vehicle.user_id) {
      Helpers.setCookie('customerID', data.vehicle.user_id, false, settings.cookieDomain)
    }
    Tracker.inline('logged_in_status', 'authenticated')
    if (window && window.$) {
      $(':input[type=email].emailAddress').val(data.email)
    }
    onUserLogin(data)
  }

  const loginTripappUser = async (email, password, loginType) => {
    if (!email || !password) return true
    const { auth } = getLoginAuthConfig()
    let reportFailedLogin = false
    if (loginType === 'manual') reportFailedLogin = true
    try {
      await SuperAgent
        .post(auth.login, {
          user: {
            email: email,
            password
          },
          user_email: email
        })
        .withCredentials()
        .type('application/json')
        .timeout({
          response: 30000,
          deadline: 60000
        })
      userLogin()
      return false
    } catch (err) {
      failedLogin(reportFailedLogin)
        // console.log( err )
      return true
    }
  }

  const transformResponse = res => {
    const flat = t => {
      var r = []
      t.forEach(v => {
        if (Array.isArray(v)) r = r.concat(flat(v))
        else r = r.concat(v)
      })
      return r
    }

    const bookings = res && flat(res.upcomingTrips.map(trip => (
      trip.bookings && trip.bookings.map(booking => ({
        booking_id: trip.id,
        booking_ref: booking.unprefixedBookingRef,
        full_ref: booking.bookingRef,
        start_at: new Date(trip.from).toISOString().slice(0, 10),
        product_type: booking.products.primary.type
      }
      ))
    )))

    const {
      profile: {
        title,
        givenName: first_name,
        familyName: last_name,
        email,
        telephones: { preferred: preferredTelephone },
        vehicles: { preferred: preferredVehicle },
        addresses: { preferred: preferredAddress },
        tripappMetadata
      },
      vouchers = {}
    } = res || {}

    return {
      title,
      first_name,
      last_name,
      email,
      bookings,
      contact_number: preferredTelephone && preferredTelephone.number,
      vehicle: tripappMetadata && preferredVehicle && {
        car_colour: preferredVehicle.colour,
        car_make: preferredVehicle.manufacturer,
        car_model: preferredVehicle.model,
        id: preferredVehicle.id,
        registration: preferredVehicle.registration,
        user_id: tripappMetadata.railsUserID
      },
      address: tripappMetadata && preferredAddress && {
        id: preferredAddress.id,
        user_id: tripappMetadata.railsUserID,
        address_1: preferredAddress.addressLines[0],
        address_2: preferredAddress.addressLines[1],
        address_3: preferredAddress.addressLines[2],
        town: preferredAddress.locality,
        county: preferredAddress.region,
        postcode: preferredAddress.postalCode,
        country: preferredAddress.country
      },
      vouchers
    }
  }

  const failedLogin = reportFailedLogin => {
    const emailExists = loginGetEmailCookie()
    const captureValue = emailExists !== '' ? 'recognised' : 'new_user'
    Tracker.inline('logged_in_status', captureValue)
    validateTripappUser(emailExists)
    if (reportFailedLogin) {
      Tracker.inline('login_failed', '1')
      dispatch({
        type: 'LOGIN_FAILED',
        data: true
      })
    }
  }
  const userLoggedInResponse = (err, res) => {
    if (err || res.status === 404 || !res.body || res.body.errors) return failedLogin(false)
    successfulLogin(res)
  }
  const userLoginRequest = callback => {
    const { auth } = getLoginAuthConfig()
    try {
      SuperAgent
        .post(auth.url)
        .set('Content-Type', 'application/json')
        .send(JSON.stringify({
          query: auth.query
        }))
        .withCredentials()
        .end(callback)
    } catch (e) {
      // return false
    }
  }
  const userLogin = () => {
    const qs = getPPCData.getQueryData()
    if (!qs || !Object.prototype.hasOwnProperty.call(qs, 'email') || qs['email'].match(/(.+)(@|%40|%2540)(.+).(.+)/)) {
      return userLoginRequest(userLoggedInResponse)
    }
    Helpers.hashToEmail(qs['email'], function (value) {
      const cookieDomain = typeof window !== 'undefined' ? window.location.host.replace('www.', '.').replace('local.', '.') : null
      Helpers.setCookie('Email', value, null, cookieDomain)
      userLoginRequest(userLoggedInResponse)
    })
  }
  const validatedTripappUser = (err, res) => {
    const prefix = ownProps.trackingPrefix ? ownProps.trackingPrefix : ''
    if (err || res.status === 404 || !res.body || !res.body.data || !res.body.data.hasAccount) {
      invalidUser()
      return Tracker.inline(prefix + 'not_valid_user_email', '1')
    }

    Tracker.inline(prefix + 'valid_user_email', '1')
    dispatch({
      type: 'VALID_USER',
      data: true
    })
  }
  const validateTripappUser = email => {
    if (!email) return
    const { userExists: { url, query} } = getLoginAuthConfig()
    if (!query) return
    query.variables.email = email.replace('+', '%2b')
    try {
      SuperAgent
        .post(url)
        .set('Content-Type', 'application/json')
        .send(JSON.stringify({
          query: query.query,
          variables: query.variables
        }))
        .withCredentials()
        .end(validatedTripappUser)
    } catch (error) {
      // console.log( error );
    }
  }
  const loginGetEmailCookie = () => {
    return Helpers.getCookie('email') || Helpers.getCookie('Email') || ''
  }
  const invalidUser = () => {
    dispatch({
      type: 'INVALID_USER'
    })
  }

  const loginSentMagicLink = () => {
    const prefix = ownProps.trackingPrefix ? ownProps.trackingPrefix : ''
    Tracker.inline(prefix + 'sent_magic_link')
    if (!store) return
    dispatch({type: 'SENT_MAGICLINK', data: true})
  }

  const loginSubmitMagicLink = (email, magicLinkUrl) => {
    const emailAddress = email.replace('+', '%2b') || loginGetEmailCookie()
    if (!emailAddress) return
    const query = getPPCData.getQueryData()
    const referrerUrl = query.referrer ? query.referrer : 'https://' + window.location.host
    SuperAgent
      .get('//static1.holidayextras.com/responsysEmailSignUpProxy.php?EMAIL_ADDRESS_=' + emailAddress + '&ORIGIN=' + encodeURI(referrerUrl) + '&_ri_=' + magicLinkUrl + '&charset_=ISO-8859-1')
      .end(() => loginSentMagicLink())
  }

  const triggerLogin = () => {
    dispatch({ type: 'TRIGGER_LOGIN' })
  }

  const triggerLoginHide = () => {
    dispatch({ type: 'TRIGGER_LOGIN_HIDE' })
  }

  return {
    invalidUser,
    userLogout,
    userLogin,
    userLogoutResponse,
    getLoginConfig,
    getLoginAuthConfig,
    loginGetEmailCookie,
    validateTripappUser,
    loginSubmitMagicLink,
    loginTripappUser,
    triggerLogin,
    triggerLoginHide
  }
}

const connectedComponent = (WrappedComponent) => connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedComponent)

module.exports = connectedComponent



// WEBPACK FOOTER //
// ./shared/stores/connects/login.jsx